export default "__VITE_ASSET__CHtoH$YM__"